import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCogs, faBoxes, faCircleNotch, faBorderAll, faHospital, faProjectDiagram, faExclamationTriangle, faHandHoldingUsd, faCar } from '@fortawesome/free-solid-svg-icons'

export default [
  {
    key: 'setup',
    id: 'setup',
    title: 'Ajustes',
    icon: <FontAwesomeIcon icon={faCogs} />,
    children: [
      //!Example
      {
        key: 'general',
        id: 'general',
        title: 'General',
        icon: <FontAwesomeIcon icon={faBorderAll} />,
        children: [
          {
            key: 'addressType',
            id: 'addressType',
            title: 'Tipos de dirección',
            icon: <FontAwesomeIcon icon={faCircleNotch} />,
            navLink: '/setup/general/addressType'
          },
          {
            key: 'department',
            id: 'department',
            title: 'Departamentos',
            icon: <FontAwesomeIcon icon={faCircleNotch} />,
            navLink: '/setup/general/department'
          }
        ]
      }
    ]
  }
]